// Ids must be kept in sync with database table Lexbe_BuildInDocFields
export enum BuiltInFieldId {
	AnnotationStatus = '37c357c7-f7ae-402f-9d77-5f934c8ef704',
	Author = '936bfd92-3251-44b0-a3f1-c125be2bcac6',
	BatesNumberStart = '0f11d06c-5b77-40b1-bd9f-f837a00d470c',
	Bcc = '418f8379-9b0f-4c05-aae3-d9502751e28a',
	Cc = '504026a6-5231-411e-91fb-d139ee44afd9',
	Confidential = 'b62384b8-dbc1-4ac2-b094-7030f53f1f99',
	ControlNumber = 'a8c65426-bdea-4df4-8d4e-2498161693d0',
	CreatedBy = '0a11d430-7f38-402a-ab2f-5d31d20d4c3c',
	Custodian = '2819b630-3248-4f58-bd8f-93fb997d2573',
	CustomDesignation = 'ca475aba-7503-4467-b8dd-ade621d9075e',
	DateCreated = 'eb854617-d7ba-4389-aecf-7e596333aa3d',
	DateLastModified = 'bc85b4a5-f46a-4b89-a7cd-8bb48345f574',
	DateReceived = 'b276efa3-0814-42f6-b36f-86b825af863c',
	DateSent = '4b395471-c8c4-435d-91bd-4d5fcfc4354e',
	DateTimeUploaded = '2d402d1d-ca36-433e-9ef5-a425bf80c7cc',
	DedupHash = 'c284e8b0-d53a-48c4-845d-7f83aa93ddd7',
	Description = '20b47e35-710a-4aba-8911-382bf308ecef',
	DocCategory = 'c68cf99e-6947-4dee-a1e7-fbb684b8b54d',
	DocDate = '3f6030d0-f3b1-4f85-95fe-096bc9ffdb1b',
	DocExtension = '52aeefc9-12e5-4eed-81cb-8461d0e10715',
	DocId = '6021245e-3a2d-4340-9d4f-f547ea85f7c9',
	DocOriginalExtension = '082164ea-dc3d-4ec9-822d-a5984ea32deb',
	DocOriginalTitle = 'a8d5f2ab-76fc-4987-ab82-d040452ace6a',
	DocSize = 'c32cceb0-ab18-4434-8f90-799bb2744883',
	DocSource = '44c6c05d-6f66-4c5e-8b76-b35df9d447d3',
	DocTitle = 'e4120808-5ca2-4e86-9401-8455ccac2096',
	DocType = '9d0de525-cf4a-4f32-bf39-b53bf5a268d7',
	EmailType = '8370758d-323c-4de3-bd58-baba0f2188e0',
	Folder = '6ceb53e2-a362-4472-975a-a5ff487c15e6',
	FromField = 'eceabbd4-2bd4-4cd5-8a87-cb161dfce945',
	HasBeenReviewed = '33128687-d5b5-40a3-98bb-3650c832f3cd',
	HasNotes = 'c7b02b0d-1ca4-409e-9c6f-4cb50e69ff0d',
	IsDuplicate = '9005ca77-ad57-4a9c-8123-eb8ee5074bb8',
	IsKey = '832226f4-a429-49ea-8a31-adc3ac5b43fb',
	Issues = '3ea9258e-ba8c-40db-a3f7-4fc79444b1fc',
	ParentId = 'd87f4313-2e07-4b0a-900a-a7a5d3b6887a',
	Placeholder = '9402810B-1D2B-4993-AF18-3D5D487B2DFC',
	LastModifiedBy = 'ab0d6214-588e-46b8-b0d5-fe96ccad8064',
	MasterDate = 'ffb07816-a3bc-4839-bb8c-e6a5d6215105',
	PageCount = '960341bd-c4d0-4795-a57a-825679eb941e',
	Privilege = '1a3bc107-8146-4d9a-979f-a027ca5bd112',
	RedactForPrivilege = '8263f50c-3817-43e0-8c41-e33eb3913b4a',
    RedactForPi = 'c1b76ad6-e01c-41f6-b1f6-ae4ac2aebdfb',
    AttorneyComments = 'ddf8e99f-4b91-439a-8a5c-f560894ded3f',
	RedactionStatus = 'd5753922-4999-43e0-81f9-ba9edee7bc18',
	Responsive = 'ac9e6138-05d1-4cfb-99dc-8e26728fd8fe',
	Score = '5aea565f-8b57-4124-8fd6-01f0587c0f68',
	SourceFilePath = '9b2a08a7-c998-4d6c-b4cb-648caf157582',
	SubjectMatter = 'c1ccf851-91dc-40db-81a7-78c2e896346a',
	TextGroupId = '63b67e76-65b4-45e6-aa10-6e9a5ea50057',
	ToField = '8b461284-e994-4239-a0de-94cb010f00cf',
	TranslationStatus = 'a1c1e73b-01ca-4f3f-95da-929573d02043',
	UploadBatchId = '6d63ff15-b8c9-432a-b931-e5c6f11bdfaa',
	WordCount = 'a308ab64-5d98-4fa2-8849-025ea7d6e476',
	WorkProduct = '32074f8f-144b-47af-b972-9353d1450d18'
}
